import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Stack } from '@mui/material'

import ActionModal from 'components/Modal/ActionModal'
import { trackEvent } from 'analytics'
import { Device } from '../types'
import { useAccessPointZonesContext } from '../AccessPointZonesContext'
import { RadioActionSource } from '../use-actions'

type DisableDeviceProps = {
  device: Device
  onClose: () => void
  source: RadioActionSource
}

const Disable = ({ device, onClose, source }: DisableDeviceProps) => {
  const { t } = useTranslation()
  const { apiActions } = useAccessPointZonesContext()

  useEffect(() => {
    trackEvent('access_point_zones_disable_opened', {
      scope: 'device',
      source,
      device_count: 1,
      connected_stations: device.connected_stations || 0
    })
  }, [])

  const handleSubmit = async () => {
    await apiActions.update({ devices: [device], enabled: false, scope: 'device', source })
    onClose()
  }

  return (
    <ActionModal
      cancelLabel={t('ui_elements.cancel')}
      confirmLabel={t('ui_elements.disable')}
      description={(
        <Stack gap={2}>
          <Box
            sx={{
              fontSize: 14,
              textAlign: 'center'
            }}
            dangerouslySetInnerHTML={{ __html: t('access_point_zones.delete.device_detail') }}
          />
          {device.connected_stations > 0 && (
            <Box
              sx={{
                fontSize: 14,
                textAlign: 'center'
              }}
              dangerouslySetInnerHTML={{ __html: t('access_point_zones.delete.detail_disclaimer', { count: device.connected_stations }) }}
            />
          )}
        </Stack>
      )}
      loading={apiActions.loading}
      onClose={onClose}
      onConfirm={handleSubmit}
      title={t('access_point_zones.delete.title')}
    />
  )
}

export default Disable